import { render, staticRenderFns } from "./VadeTarihiXGunGecmisFaturalarView.vue?vue&type=template&id=0b488853"
import script from "./VadeTarihiXGunGecmisFaturalarView.vue?vue&type=script&lang=js"
export * from "./VadeTarihiXGunGecmisFaturalarView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports